var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamePad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5021 0.455078H10.5103V6.43466H13.5021V0.455078Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9717 21.3836L22.0269 11.6668C21.5782 9.57395 19.6334 7.92957 17.3895 7.92957C14.6969 7.92957 13.0513 10.4709 12.7522 10.9194H11.2562C10.957 10.4709 9.31151 7.92957 6.61884 7.92957C4.37494 7.92957 2.43022 9.57395 1.98145 11.6668L0.0367331 21.3836C-0.11286 22.43 0.186326 23.4765 1.08389 23.9249C1.98145 24.5229 3.0286 24.3734 3.92616 23.7755L9.46111 19.8887H14.3977L19.9326 23.9249C20.8302 24.5229 21.7278 24.6724 22.7749 24.0744C23.6725 23.4765 24.1212 22.43 23.9717 21.3836ZM9.01233 15.404H7.5164V16.8989H6.02046V15.404H4.52453V13.9091H6.02046V12.4142H7.5164V13.9091H9.01233V15.404ZM16.492 16.8989H14.9961V15.404H16.492V16.8989ZM16.492 12.4142H17.9879V13.9091H16.492V12.4142ZM19.4839 16.8989H17.9879V15.404H19.4839V16.8989Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4273_148436",
    x1: 10.5103,
    y1: 3.44487,
    x2: 13.497,
    y2: 3.44391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4273_148436",
    x1: -1.18604e-9,
    y1: 16.1923,
    x2: 23.9592,
    y2: 16.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePad);
export default __webpack_public_path__ + "static/media/game-pad.206fa990e726a0aa70c7be55499fe30b.svg";
export { ForwardRef as ReactComponent };